import { AcquiringItem, AcquiringSettings, RefillType } from 'app/dataTypes/acquiring/settings'


const defaultRes: Map<string, AcquiringItem> = new Map()

export const useAcquiringItemsByRefillType = (
  acquiring: AcquiringSettings,
  refillType: RefillType | null
) => {
  if (refillType) {
    return acquiring[refillType] || defaultRes
  }
  return defaultRes
}
